var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('v-toolbar',[_c('v-toolbar-title',[_vm._v("DBC")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }